/**
 * ./exercise7/Exercise7.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // useNavigate instead of useHistory
import "../exercise2/Exercise2.css";
import Curtain from "../components/Curtain"; // Import the reusable Curtain component
import Icon from "./icons/excercise7icon.svg"; // Import the person icon
import { API_BASE_URL } from "../config";

const Exercise6 = () => {
  const [isCurtainActive, setIsCurtainActive] = useState(true);
  const navigate = useNavigate(); // Create a navigate function for navigation
  const [userData, setUserData] = useState(null); // We added this

  // We added this
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    // After the curtain disappears, we set isCurtainActive to false
    const timer = setTimeout(() => {
      setIsCurtainActive(false);
    }, 2000); // Match the duration of the curtain disappearance

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  const handlePersonClick = () => {
    navigate("/exercise6intro");
  };

  return (
    <div className="exercise2-page">
      {/* Display the curtain and set it to "disappear" */}
      {isCurtainActive && <Curtain disappear={true} duration={2000} />}

      {/* Text content */}
      <div className="exercise2-header">
        <h1>Exercise 6: Flash Reading Training</h1>
      </div>

      {/* Blue bottom area */}
      <div className="exercise2-bottom">
        <img
          className="exercise2-icon"
          src={Icon}
          alt="Icon"
          onClick={handlePersonClick} // Add onClick event to handle navigation
        />
        <button
          className="start-exercise"
          onClick={() => {
            if (userData.exercisesUnlocked[5] >= 1) {
              navigate("/exercise7intro");
            } else {
              navigate("/Warmupwelcome", { state: { exerciseNumber: 7} });
            }
          }}
        >
          <b>START</b>
        </button>
      </div>
    </div>
  );
};

export default Exercise6;
